import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=3a3df253&rel=stylesheet%2Fscss&lang=scss"

const __exports__ = script;

export default __exports__